/**
 * Le sous-compte de l'utilisateur connecté, chargé une fois et partagé.
 *
 * La barre latérale y prend le logo et la raison sociale, l'écran Identité y prend les
 * valeurs du formulaire et appelle `refresh()` après enregistrement. Sans ce contexte,
 * chaque écran referait le même appel, et la barre latérale ne saurait pas qu'un logo
 * vient de changer.
 *
 * Repris de sa version, aux chemins d'import près.
 */
import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useAuth } from '@/shared/auth/AuthContext';
import api from '@/shared/api/client';

const OperatorContext = createContext(null);

export function OperatorProvider({ children }) {
  const { user } = useAuth();
  const [operator, setOperator] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user.role === 'super_admin') {
      setOperator(null);
      return;
    }
    setLoading(true);
    try {
      const res = await api.get('/operator/me');
      setOperator(res.data);
    } catch {
      setOperator(null);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <OperatorContext.Provider value={{ operator, loading, refresh }}>
      {children}
    </OperatorContext.Provider>
  );
}

export function useOperator() {
  const ctx = useContext(OperatorContext);
  if (!ctx) return { operator: null, loading: false, refresh: () => {} };
  return ctx;
}
